import angular from 'angular';

const componentOptions = {
    bindings: {
        model: '=',
        modules: '=',
        dataequalrow: '=',
        selected: '=',
        specialMealIsClose: '='
    },
    controllerAs: 'ibGastroProposalCtrl',
    templateUrl: [
        '$rootScope', function ($rootScope) {
            return $rootScope.routes.templates + 'ib-gastronomic-proposal-component.html';
        }]
};


const componentInfo = {
    module: 'ib-gastronomic-proposal-component',
    selector: 'ibGastronomicProposalComponent',
    inject: ['$scope', '$window', 'DatalayerUtilsService', 'AncillariesConstants'],
    required: ['']
};


export class IbGastronomicProposal implements angular.IController {
    public model;
    public selected;
    public specialMealIsClose;
    constructor (private $scope: angular.IScope) {
    }

    callback = (): void => {
        this.$scope.$emit(this.model.eventName);
    };

    hasSpecialMealsSelected (): boolean {
        return this.selected > 0;
    }
}


try {
    const mod = angular.module(componentInfo.module);
    IbGastronomicProposal.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: IbGastronomicProposal })
    );
} catch (error) {
    const mod = angular.module(componentInfo.module, componentInfo.required);
    IbGastronomicProposal.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: IbGastronomicProposal })
    );
}